<booking-services-mobile *ngIf="isMobile"></booking-services-mobile>
<booking-services-desktop *ngIf="!isMobile"></booking-services-desktop>